import { Pipe } from '@angular/core'
import chaining from '../../core/helpers/chaining'

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe {

  transform(items, orderBy, asc = true) {
    if (!orderBy || !orderBy) {
      return items;
    }

    if (asc && Array.isArray(items)) {
      return Array.from(items).sort((prev: any, cur: any) => {
        if (chaining(prev, orderBy) > chaining(cur, orderBy))
          return -1
        if (chaining(prev, orderBy) < chaining(cur, orderBy))
          return 1
        return 0
      })
    }
    else if (Array.isArray(items)) {
      return Array.from(items).sort((prev: any, cur: any) => {
        if (chaining(cur, orderBy) > chaining(prev, orderBy))
          return -1
        if (chaining(cur, orderBy) < chaining(prev, orderBy))
          return 1
        return 0
      })
    }
    return []
  }
}
